import { render, staticRenderFns } from "./MatchCard.vue?vue&type=template&id=22855127&"
import script from "./MatchCard.vue?vue&type=script&lang=js&"
export * from "./MatchCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports